<template>
	<OrganismFormLead
		:webhook="LeadFormWebhooksEnum.ZFT"
		:conversion-value="ConversionValuesEnum.ZFT"
		:product-name="LeadFormProductsEnum.ZFT"
		form-name="zft"
		submit-button-text="MamaFit informatie aanvragen"
		submit-button-icon="fa-heart"
	/>
</template>

<script lang="ts" setup>
import { LeadFormWebhooksEnum } from '#fit/core/enums/LeadFormWebhooksEnum';
import { ConversionValuesEnum } from '#fit/core/enums/ConversionValuesEnum';
import { LeadFormProductsEnum } from '#fit/core/enums/LeadFormProductsEnum';
</script>
